import { render, staticRenderFns } from "./quest-tracking-data-item-route.vue?vue&type=template&id=4c7028b2&scoped=true"
import script from "./quest-tracking-data-item-route.vue?vue&type=script&lang=js"
export * from "./quest-tracking-data-item-route.vue?vue&type=script&lang=js"
import style0 from "./quest-tracking-data-item-route.vue?vue&type=style&index=0&id=4c7028b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7028b2",
  null
  
)

export default component.exports